<template>
	<el-container class="wrapper">
		<Aside></Aside>
		<el-container direction="vertical">
			<Header></Header>
			<div class="main">
				<router-view :key="key"></router-view>
			</div>
		</el-container>
	</el-container>

</template>

<script>
	import Header from '@/components/Header'
	import Aside from '@/components/Aside'
	export default {
		components: {
			Header,
			Aside
		},
		computed: {
			key() {
				return this.$route.path
			}
		}
	}
</script>

<style>
	.wrapper {
		height: 100%;
	}

	.main {
		width: 100%;
		flex: 1;
		padding: 20px;
		background: #f0f2f5;
		box-sizing: border-box;
		overflow: hidden;
	}
</style>
